import { Resource } from '../../security/permissions/rolePerimissionsUtil';

export type MenuItem = {
    label: string;
    route: string;
    resource: Resource;
    requiredAction?: 'read' | 'write' | 'edit' | 'delete'; // Optional specific action requirement
};

export const leftMenuItems: MenuItem[] = [
    {
        label: 'Users',
        route: '/users',
        resource: 'users',
        requiredAction: 'read', // Need read permission to see menu
    },
    {
        label: 'Requests',
        route: '/requests',
        resource: 'requests',
        requiredAction: 'read',
    },
    {
        label: 'Store',
        route: '/store',
        resource: 'store',
        requiredAction: 'read',
    },
];

